import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="account.email-label" defaultMessage="Email" />;
